module.exports = __webpack_public_path__ + "img/box-arrow-up-left.79ff0b1c.svg";